export default __webpack_public_path__ + "1712e84e1f900f4f07f6d4dac71cd4ac.svg";